import { render, staticRenderFns } from "./Top10ProductSales.vue?vue&type=template&id=c6c04816&"
import script from "./Top10ProductSales.vue?vue&type=script&lang=js&"
export * from "./Top10ProductSales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QSeparator,QTable,QTr,QTh,QTd} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QSeparator,QTable,QTr,QTh,QTd})
